import React from 'react';
import NavMenu from '../../components/NavMenu';
// import {useFormik} from 'formik';

const MyAccounts = () => {
  // const formik = useFormik({
  //   initialValues: {
  //     firstName: '',
  //     lastName: '',
  //   }
  // });
  return <div>
      <p style={{marginTop: 50}}>My Accounts Body</p>
  </div>;
}

export default MyAccounts;